export default function Convert3dCubeBoldIcon() {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.0002 22.75C14.7302 22.75 14.4802 22.6 14.3502 22.37C14.2202 22.14 14.2202 21.85 14.3602 21.62L15.4102 19.87C15.6202 19.51 16.0802 19.4 16.4402 19.61C16.8002 19.82 16.9102 20.28 16.7002 20.64L16.4302 21.09C19.1902 20.44 21.2602 17.96 21.2602 15C21.2602 14.59 21.6002 14.25 22.0102 14.25C22.4202 14.25 22.7602 14.59 22.7602 15C22.7502 19.27 19.2702 22.75 15.0002 22.75Z"
          className={"svg-fill"}
        />
        <path
          d="M2 9.75C1.59 9.75 1.25 9.41 1.25 9C1.25 4.73 4.73 1.25 9 1.25C9.27 1.25 9.52 1.4 9.65 1.63C9.78 1.86 9.78 2.15 9.64 2.38L8.59 4.14C8.38 4.49 7.92 4.61 7.56 4.39C7.21 4.18 7.09 3.72 7.31 3.36L7.58 2.91C4.81 3.56 2.75 6.04 2.75 9C2.75 9.41 2.41 9.75 2 9.75Z"
          className={"svg-fill"}
        />
        <path
          d="M10.67 13.85L7.52996 12.16C7.19996 11.98 6.79996 11.98 6.46996 12.16L3.32996 13.85C3.09996 13.97 2.95996 14.22 2.95996 14.49C2.95996 14.76 3.09996 15.01 3.32996 15.13L6.46996 16.82C6.63996 16.91 6.81996 16.95 6.99996 16.95C7.17996 16.95 7.35996 16.91 7.52996 16.82L10.67 15.13C10.9 15.01 11.04 14.76 11.04 14.49C11.04 14.22 10.89 13.98 10.67 13.85Z"
          className={"svg-fill"}
        />
        <path
          d="M5.95 17.41L3.03 15.95C2.81 15.84 2.55 15.85 2.33 15.98C2.13 16.11 2 16.34 2 16.59V19.35C2 19.83 2.26 20.26 2.69 20.47L5.61 21.93C5.71 21.97 5.82 22 5.93 22C6.06 22 6.19 21.96 6.31 21.89C6.52 21.76 6.65 21.53 6.65 21.28V18.52C6.65 18.05 6.38 17.62 5.95 17.41Z"
          className={"svg-fill"}
        />
        <path
          d="M11.6596 15.98C11.4496 15.85 11.1896 15.84 10.9596 15.95L8.03961 17.41C7.60961 17.62 7.34961 18.05 7.34961 18.53V21.29C7.34961 21.54 7.47961 21.77 7.68961 21.9C7.80961 21.96 7.93961 22 8.06961 22C8.17961 22 8.28961 21.97 8.38961 21.92L11.3096 20.46C11.7396 20.25 11.9996 19.82 11.9996 19.34V16.58C11.9996 16.34 11.8696 16.11 11.6596 15.98Z"
          className={"svg-fill"}
        />
        <path
          d="M20.67 3.83L17.53 2.14C17.2 1.96 16.8 1.96 16.47 2.14L13.33 3.83C13.1 3.95 12.96 4.2 12.96 4.47C12.96 4.74 13.1 4.99001 13.33 5.11L16.47 6.8C16.64 6.89001 16.82 6.93 17 6.93C17.18 6.93 17.36 6.89001 17.53 6.8L20.67 5.11C20.9 4.99001 21.04 4.74 21.04 4.47C21.04 4.19 20.89 3.95 20.67 3.83Z"
          className={"svg-fill"}
        />
        <path
          d="M15.95 7.37999L13.03 5.91999C12.81 5.80999 12.55 5.81999 12.33 5.94999C12.13 6.07999 12 6.30999 12 6.55999V9.31999C12 9.79999 12.26 10.23 12.69 10.44L15.61 11.9C15.71 11.95 15.82 11.98 15.93 11.98C16.06 11.98 16.19 11.94 16.31 11.87C16.52 11.74 16.65 11.51 16.65 11.26V8.49999C16.65 8.01999 16.38 7.58999 15.95 7.37999Z"
          className={"svg-fill"}
        />
        <path
          d="M21.6596 5.94999C21.4496 5.81999 21.1896 5.80999 20.9596 5.91999L18.0396 7.37999C17.6096 7.58999 17.3496 8.01999 17.3496 8.49999V11.26C17.3496 11.51 17.4796 11.74 17.6896 11.87C17.8096 11.94 17.9396 11.98 18.0696 11.98C18.1796 11.98 18.2896 11.95 18.3896 11.9L21.3096 10.44C21.7396 10.22 21.9996 9.78999 21.9996 9.31999V6.55999C21.9996 6.30999 21.8696 6.07999 21.6596 5.94999Z"
          className={"svg-fill"}
        />
      </svg>
    </>
  );
}
